// Tiny localStorage-backed ProgramsCache adapter for web-rnw. Web has no
// AsyncStorage, so without this the programs/progress lists start from null on
// every load and depend entirely on the network landing — a transient
// per-program progress failure then has nothing to fall back on and the Plan
// carousel order flips (Antenore 2026-06-18). Cache-first here mirrors the
// mobile AsyncStorage adapters ([[reference_web_rnw_needs_swr_cache]]).
import { webStorage } from "./webStorage";

export function lsCache<T>(key: string) {
  return {
    read: async (): Promise<T | null> => {
      try {
        const raw = webStorage.getItem(key);
        return raw ? (JSON.parse(raw) as T) : null;
      } catch {
        return null; // private mode / corrupt entry → treat as empty
      }
    },
    write: async (value: T): Promise<void> => {
      try {
        webStorage.setItem(key, JSON.stringify(value));
      } catch {
        // quota exceeded / private mode — non-fatal, network still drives.
      }
    },
  };
}
